
// import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./ProductDisplay.css";
// import star_icon from "../Assets/Frontend_Assets/star_icon.png";
// import star_dull_icon from "../Assets/Frontend_Assets/star_dull_icon.png";
// import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
// import ProductSkeleton from "../productskeleton/ProductSkeleton";
// import { ShopContext } from "../../Context/ShopContext";

// const ProductDisplay = ({ product }) => {
//   const { addToCart } = useContext(ShopContext);
// const navigate = useNavigate();



//   const [activeImg, setActiveImg] = useState(0);
//   const [selectedSize, setSelectedSize] = useState(null);
//   const [qty, setQty] = useState(1);
//   const [zoomPos, setZoomPos] = useState({ x: 50, y: 50 });
//   const [showCartModal, setShowCartModal] = useState(false);
// useEffect(() => {
//   if (showCartModal) {
//     document.body.classList.add("modal-open");
//   } else {
//     document.body.classList.remove("modal-open");
//   }

//   const esc = (e) => {
//     if (e.key === "Escape") setShowCartModal(false);
//   };

//   window.addEventListener("keydown", esc);
//   return () => window.removeEventListener("keydown", esc);
// }, [showCartModal]);


//   // ✅ CONDITIONAL RENDER — AFTER HOOKS
//   if (!product) {
//     return <ProductSkeleton />;
//   }
//   /* ---------------- IMAGE LOGIC ---------------- */
//   const rawImages = [
//     product.image,
//     ...(product.detail_images || []),
//   ].filter(Boolean);

//   const images = [...rawImages];
//   while (images.length < 4) images.push(placeholder);

//   const thumbnails = images.slice(0, 4);
//   const mainImage = thumbnails[activeImg] || placeholder;

//   /* ---------------- STOCK ---------------- */
//   const isStitched = product.type === "stitched";

//   const sizeOptions = isStitched ? Object.keys(product.sizes || {}) : [];

//   const totalStock = isStitched
//     ? Object.values(product.sizes || {}).reduce(
//         (a, b) => a + Number(b || 0),
//         0
//       )
//     : Number(product.total_qty || 0);

//   const currentStock =
//     isStitched && selectedSize
//       ? Number(product.sizes[selectedSize])
//       : totalStock;

//   /* ---------------- ADD TO CART ---------------- */
//   const handleAddToCart = () => {
//     if (totalStock <= 0) return alert("Out of stock");
//     if (isStitched && !selectedSize) return alert("Please select size");

//     addToCart(product.product_id, selectedSize, Number(qty));
//     setShowCartModal(true);
//   };



//   /* ---------------- MAGNIFIER ---------------- */
//   const handleMouseMove = (e) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const x = ((e.clientX - rect.left) / rect.width) * 100;
//     const y = ((e.clientY - rect.top) / rect.height) * 100;
//     setZoomPos({ x, y });
//   };

//   return (
//     <>
//       <div className="pd-container">
//         {/* LEFT */}
//         <div className="pd-left">
//           <div className="pd-thumbs">
//             {thumbnails.map((img, i) => (
//               <img
//                 key={i}
//                 src={img}
//                 className={i === activeImg ? "active" : ""}
//                 onClick={() => setActiveImg(i)}
//                 onError={(e) => (e.target.src = placeholder)}
//               />
//             ))}
//           </div>

//           <div
//             className="pd-main-img magnifier"
//             onMouseMove={handleMouseMove}
//             style={{
//               backgroundImage: `url(${mainImage})`,
//               backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
//             }}
//           >
//             <img
//               src={mainImage}
//               alt={product.product_name}
//               onError={(e) => (e.target.src = placeholder)}
//             />
//           </div>
//         </div>

//         {/* RIGHT */}
//         <div className="pd-right">
//           <h1>{product.product_name}</h1>

//           <div className="pd-rating">
//             <img src={star_icon} />
//             <img src={star_icon} />
//             <img src={star_icon} />
//             <img src={star_icon} />
//             <img src={star_dull_icon} />
//             <span>(122 reviews)</span>
//           </div>

//           <div className="pd-price">
//             {product.old_price && (
//               <span className="old">Rs {product.old_price}</span>
//             )}
//             <span className="new">Rs {product.new_price}</span>
//           </div>

//           <p className="pd-desc">
//             {product.description || "No description available."}
//           </p>

//           {/* SIZE */}
//           {isStitched && (
//             <div className="pd-sizes">
//               <h3>Select Size</h3>
//               <div className="size-grid">
//                 {sizeOptions.map((sz) => {
//                   const stock = Number(product.sizes[sz] || 0);
//                   return (
//                     <button
//                       key={sz}
//                       disabled={stock <= 0}
//                       className={selectedSize === sz ? "active" : ""}
//                       onClick={() => setSelectedSize(sz)}
//                     >
//                       {sz.toUpperCase()}
//                       <small>{stock <= 0 ? "Out" : stock}</small>
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           {/* QTY */}
//           <div className="pd-qty">
//             <h3>Quantity</h3>
//             <div className="qty-box">
//               <button onClick={() => setQty((q) => Math.max(1, q - 1))}>−</button>
//               <input
//                 type="number"
//                 min="1"
//                 max={currentStock}
//                 value={qty}
//                 onChange={(e) => setQty(e.target.value)}
//               />
//               <button onClick={() => setQty((q) => q + 1)}>+</button>
//             </div>
//             <p className="stock-info">Available: {currentStock}</p>
//           </div>

//           <button
//             className="pd-add-btn"
//             disabled={totalStock <= 0}
//             onClick={handleAddToCart}
//           >
//             {totalStock > 0 ? "Add to Cart" : "Out of Stock"}
//           </button>

//           {/* MOBILE STICKY */}
//           <div className="mobile-sticky-cart">
//             <span className="price">Rs {product.new_price}</span>
//             <button onClick={handleAddToCart}>Add to Cart</button>
//           </div>
//         </div>
//       </div>

//       {/* ADD TO CART MODAL */}
//      {showCartModal && (
//   <div
//     className="cart-modal-backdrop"
//     onClick={() => setShowCartModal(false)}
//   >
//     <div
//       className="cart-modal"
//       onClick={(e) => e.stopPropagation()}
//     >
//       <h2>Added to Cart 🛒</h2>
//       <p>Your product has been added successfully.</p>

//       <div className="cart-modal-actions">
//         <button
//           className="continue"
//           onClick={() => setShowCartModal(false)}
//         >
//           Continue Shopping
//         </button>

//         <button
//           className="go-cart"
//           onClick={() => navigate("/cart")}
//         >
//           Go to Cart
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//     </>
//   );
// };

// export default ProductDisplay;




// import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./ProductDisplay.css";
// import star_icon from "../Assets/Frontend_Assets/star_icon.png";
// import star_dull_icon from "../Assets/Frontend_Assets/star_dull_icon.png";
// import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
// import ProductSkeleton from "../productskeleton/ProductSkeleton";
// import { ShopContext } from "../../Context/ShopContext";

// const ProductDisplay = ({ product }) => {
//   const { addToCart } = useContext(ShopContext);
//   const navigate = useNavigate();

//   const isMobile = window.innerWidth <= 768;

//   const [activeImg, setActiveImg] = useState(0);
//   const [selectedSize, setSelectedSize] = useState(null);
//   const [qty, setQty] = useState(1);
//   const [zoomPos, setZoomPos] = useState({ x: 50, y: 50 });
//   const [showCartModal, setShowCartModal] = useState(false);
//   const [showZoomModal, setShowZoomModal] = useState(false);

//   useEffect(() => {
//     document.body.classList.toggle("modal-open", showCartModal || showZoomModal);
//     return () => document.body.classList.remove("modal-open");
//   }, [showCartModal, showZoomModal]);

//   if (!product) return <ProductSkeleton />;

//   /* ---------------- IMAGES ---------------- */
//   const rawImages = [product.image, ...(product.detail_images || [])].filter(Boolean);
//   const images = [...rawImages];
//   while (images.length < 4) images.push(placeholder);

//   const thumbnails = images.slice(0, 4);
//   const mainImage = thumbnails[activeImg] || placeholder;

//   /* ---------------- STOCK ---------------- */
//   const isStitched = product.type === "stitched";
//   const sizeOptions = isStitched ? Object.keys(product.sizes || {}) : [];

//   const totalStock = isStitched
//     ? Object.values(product.sizes || {}).reduce((a, b) => a + Number(b || 0), 0)
//     : Number(product.total_qty || 0);

//   const currentStock =
//     isStitched && selectedSize
//       ? Number(product.sizes[selectedSize])
//       : totalStock;

//   /* ---------------- ADD TO CART ---------------- */
//   const handleAddToCart = () => {
//     if (totalStock <= 0) return alert("Out of stock");
//     if (isStitched && !selectedSize) return alert("Please select size");

//     addToCart(product.product_id, selectedSize, Number(qty) || 1);
//     setShowCartModal(true);
//   };
// //   const handleAddToCart = () => {
// //     if (totalStock <= 0) return alert("Out of stock");
// //     if (isStitched && !selectedSize) return alert("Please select size");

// //     addToCart(product.product_id, selectedSize, Number(qty));
// //     setShowCartModal(true);
// //   };
//   /* ---------------- DESKTOP HOVER ZOOM ---------------- */
//   const handleMouseMove = (e) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const x = ((e.clientX - rect.left) / rect.width) * 100;
//     const y = ((e.clientY - rect.top) / rect.height) * 100;
//     setZoomPos({ x, y });
//   };

//   return (
//     <>
//       <div className="pd-container">
//         {/* LEFT */}
//         <div className="pd-left">
//           <div className="pd-thumbs">
//             {thumbnails.map((img, i) => (
//               <img
//                 key={i}
//                 src={img}
//                 className={i === activeImg ? "active" : ""}
//                 onClick={() => setActiveImg(i)}
//                 onError={(e) => (e.target.src = placeholder)}
//               />
//             ))}
//           </div>

//           <div
//             className={`pd-main-img ${!isMobile ? "magnifier" : ""}`}
//             onMouseMove={!isMobile ? handleMouseMove : undefined}
//             onClick={() => isMobile && setShowZoomModal(true)}
//             style={
//               !isMobile
//                 ? {
//                     backgroundImage: `url(${mainImage})`,
//                     backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
//                   }
//                 : {}
//             }
//           >
//             <img
//               src={mainImage}
//               alt={product.product_name}
//               onError={(e) => (e.target.src = placeholder)}
//             />
//           </div>
//         </div>

//         {/* RIGHT */}
//         <div className="pd-right">
//           <h1>{product.product_name}</h1>

//           <div className="pd-rating">
//             <img src={star_icon} />
//             <img src={star_icon} />
//             <img src={star_icon} />
//             <img src={star_icon} />
//             <img src={star_dull_icon} />
//             <span>(122 reviews)</span>
//           </div>

//           <div className="pd-price">
//             {product.old_price && <span className="old">Rs {product.old_price}</span>}
//             <span className="new">Rs {product.new_price}</span>
//           </div>

//           <p className="pd-desc">
//             {product.description || "No description available."}
//           </p>

//           {/* SIZE */}
//           {isStitched && (
//             <div className="pd-sizes">
//               <h3>Select Size</h3>
//               <div className="size-grid">
//                 {sizeOptions.map((sz) => {
//                   const stock = Number(product.sizes[sz] || 0);
//                   return (
//                     <button
//                       key={sz}
//                       disabled={stock <= 0}
//                       className={selectedSize === sz ? "active" : ""}
//                       onClick={() => setSelectedSize(sz)}
//                     >
//                       {sz.toUpperCase()}
//                       <small>{stock <= 0 ? "Out" : stock}</small>
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           {/* QTY */}
//           <div className="pd-qty">
//             <h3>Quantity</h3>
//             <div className="qty-box">
//               <button onClick={() => setQty((q) => Math.max(1, q - 1))}>−</button>
//               <input
//                 type="number"
//                 min="1"
//                 max={currentStock}
//                 value={qty}
//                 onChange={(e) => setQty(Number(e.target.value) || 1)}
//               />
//               <button onClick={() => setQty((q) => q + 1)}>+</button>
//             </div>
//             <p className="stock-info">Available: {currentStock}</p>
//           </div>

//           <button className="pd-add-btn" disabled={totalStock <= 0} onClick={handleAddToCart}>
//             {totalStock > 0 ? "Add to Cart" : "Out of Stock"}
//           </button>

//           {/* MOBILE STICKY */}
//           <div className="mobile-sticky-cart">
//             <span className="price">Rs {product.new_price}</span>
//             <button onClick={handleAddToCart}>Add to Cart</button>
//           </div>
//         </div>
//       </div>

//       {/* ADD TO CART MODAL */}
//       {showCartModal && (
//         <div className="cart-modal-backdrop" onClick={() => setShowCartModal(false)}>
//           <div className="cart-modal" onClick={(e) => e.stopPropagation()}>
//             <h2>Added to Cart 🛒</h2>
//             <p>Your product has been added successfully.</p>
//             <div className="cart-modal-actions">
//               <button className="continue" onClick={() => setShowCartModal(false)}>
//                 Continue Shopping
//               </button>
//               <button className="go-cart" onClick={() => navigate("/cart")}>
//                 Go to Cart
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* MOBILE FULLSCREEN ZOOM */}
//       {showZoomModal && (
//         <div className="zoom-modal" onClick={() => setShowZoomModal(false)}>
//           <img
//             src={mainImage}
//             className="zoom-image"
//             alt="Zoom"
//             onClick={(e) => e.stopPropagation()}
//           />
//         </div>
//       )}
//     </>
//   );
// };

// export default ProductDisplay;
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ProductDisplay.css";
import star_icon from "../Assets/Frontend_Assets/star_icon.png";
import star_dull_icon from "../Assets/Frontend_Assets/star_dull_icon.png";
//import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
import ProductSkeleton from "../productskeleton/ProductSkeleton";
import { ShopContext } from "../../Context/ShopContext";

const ProductDisplay = ({ product }) => {
  const { addToCart } = useContext(ShopContext);
  const navigate = useNavigate();

  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

  const [activeImg, setActiveImg] = useState(0);
  const [selectedSize, setSelectedSize] = useState(null);
  const [qty, setQty] = useState(1);
  const [zoomPos, setZoomPos] = useState({ x: 50, y: 50 });
  const [showCartModal, setShowCartModal] = useState(false);
  const [showZoomModal, setShowZoomModal] = useState(false);

  useEffect(() => {
    document.body.classList.toggle(
      "modal-open",
      showCartModal || showZoomModal
    );
    return () => document.body.classList.remove("modal-open");
  }, [showCartModal, showZoomModal]);

  if (!product) return <ProductSkeleton />;

  /* IMAGES */
  const rawImages = [product.image, ...(product.detail_images || [])].filter(Boolean);
  const images = [...rawImages];
  // while (images.length < 4) images.push(placeholder);

  const thumbnails = images.slice(0, 4);
  const mainImage = thumbnails[activeImg];

  /* STOCK */
  const isStitched = product.type === "shoes";
  const sizeOptions = isStitched ? Object.keys(product.sizes || {}) : [];

  const totalStock = isStitched
    ? Object.values(product.sizes || {}).reduce((a, b) => a + Number(b || 0), 0)
    : Number(product.total_qty || 0);

  const currentStock =
    isStitched && selectedSize
      ? Number(product.sizes[selectedSize])
      : totalStock;

  /* ADD TO CART */
  const handleAddToCart = () => {
    if (totalStock <= 0) return alert("Out of stock");
    if (isStitched && !selectedSize) return alert("Please select size");

    addToCart(product.product_id, selectedSize, qty);
    setShowCartModal(true);
  };

  /* DESKTOP HOVER ZOOM */
  const handleMouseMove = (e) => {
    if (isTouchDevice) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoomPos({ x, y });
  };
const handleBuyNow = () => {
  if (totalStock <= 0) return alert("Out of stock");
  if (isStitched && !selectedSize) return alert("Please select size");

  // add to cart first
  addToCart(product.product_id, selectedSize, qty);

  // redirect to checkout
  navigate("/checkout/address");
};
  return (
    <>
      <div className="pd-container">
        {/* LEFT */}
        <div className="pd-left">
          <div className="pd-thumbs">
            {thumbnails.map((img, i) => (
              <img
  key={i}
  src={img}
  alt=""
  className={i === activeImg ? "active" : ""}
  onClick={() => setActiveImg(i)}
  // onError={(e) => (e.target.src = placeholder)}
/>

            ))}
          </div>

          <div
            className={`pd-main-img ${!isTouchDevice ? "magnifier" : ""}`}
            onMouseMove={!isTouchDevice ? handleMouseMove : undefined}
            onClick={() => isTouchDevice && setShowZoomModal(true)}
            style={
              !isTouchDevice
                ? {
                    backgroundImage: `url(${mainImage})`,
                    backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
                  }
                : {}
            }
          >
            <img
              src={mainImage}
              alt={product.product_name}
              draggable={false}
              // onError={(e) => (e.target.src = placeholder)}
            />
          </div>
        </div>

        {/* RIGHT */}
        <div className="pd-right">
          <h1>{product.product_name}</h1>

        <div className="pd-rating">
  {[1, 2, 3, 4].map((i) => (
    <img key={i} src={star_icon} alt="" />
  ))}
  <img src={star_dull_icon} alt="" />
  <span>(122 reviews)</span>
</div>


          <div className="pd-price">
            {product.old_price && (
              <span className="old">Rs {product.old_price}</span>
            )}
            <span className="new">Rs {product.new_price}</span>
          </div>

          <p className="pd-desc">
            {product.description || "No description available."}
          </p>

          {/* SIZE */}
          {isStitched && (
            <div className="pd-sizes">
              <h3>Select Size</h3>
              <div className="size-grid">
                {sizeOptions.map((sz) => {
                  const stock = Number(product.sizes[sz] || 0);
                  return (
                    <button
                      key={sz}
                      disabled={stock <= 0}
                      className={selectedSize === sz ? "active" : ""}
                      onClick={() => setSelectedSize(sz)}
                    >
                      {sz.toUpperCase()}
                      <small>{stock <= 0 ? "Out" : ""}</small>
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* QTY */}
          <div className="pd-qty">
            <h3>Quantity</h3>
            <div className="qty-box">
              <button onClick={() => setQty((q) => Math.max(1, q - 1))}>−</button>
              <input
                type="number"
                min="1"
                max={currentStock}
                value={qty}
                onChange={(e) => setQty(Number(e.target.value) || 1)}
              />
              <button onClick={() => setQty((q) => q + 1)}>+</button>
            </div>
            {/* <p className="stock-info">Available: {currentStock}</p> */}
          </div>
<div className="pd-actions">
          <button
            className="pd-add-btn"
            disabled={totalStock <= 0}
            onClick={handleAddToCart}
          >
            {totalStock > 0 ? "Add to Cart" : "Out of Stock"}
          </button>
          <button
    className="pd-buy-btn"
    disabled={totalStock <= 0}
    onClick={handleBuyNow}
  >
    Buy Now
  </button>
  </div>
        </div>
      </div>

      {/* CART MODAL */}
      {showCartModal && (
        <div className="cart-modal-backdrop" onClick={() => setShowCartModal(false)}>
          <div className="cart-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Added to Cart 🛒</h2>
            <p>Your product has been added successfully.</p>
            <div className="cart-modal-actions">
              <button className="continue" onClick={() => setShowCartModal(false)}>
                Continue Shopping
              </button>
              <button className="go-cart" onClick={() => navigate("/cart")}>
                Go to Cart
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MOBILE FULLSCREEN ZOOM */}
      {showZoomModal && (
        <div className="zoom-modal" onClick={() => setShowZoomModal(false)}>
          <img
            src={mainImage}
            className="zoom-image"
            alt="Zoom"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};

export default ProductDisplay;
